/**
 * Functionality around the upload Group selection widget.
 *
 * Meant to be used both inside the widget component as well as its
 * parent component: To make that work, the component is expected to
 * define its own this.selectedUploadGroupId as the model that is
 * changed.
 *
 * Depends on:
 *   - this.selectedUploadGroupId
 *   - this.contentToReplace (optional)
 */

export default {
  computed: {
    uploadgroups() {
      return this.$store.getters.uploadgroups;
    },
    selectedUploadGroup() {
      for (var i = 0; i < this.uploadgroups.length; i++) {
        if (this.uploadgroups[i].id == this.selectedUploadGroupId) {
          return this.uploadgroups[i];
        }
      }
      return null;
    },
  },
  methods: {
    /**
     * We want to preselect the uploadgroup if there is only one, but
     * force the user to pick one himself explicitly if there are more.
     *
     * When replacing a single Spot, we preselect it's Group here.
     */
    getInitialUploadgroupId() {
      const numUploadGroups = this.uploadgroups.length;
      if (numUploadGroups === 0) {
        return null;
      } else if (numUploadGroups === 1) {
        const firstGroup = this.uploadgroups[0];
        return firstGroup.id;
      } else {
        if (this.contentToReplace) {
          const groupId = this.contentToReplace.group.id;
          return groupId;
        }
        // Multiple choices? Force user to pick one.
        return null;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/uploadGroupSelect.js